export const DISTRIBUTION_TYPES = ['isolated', 'specific', 'widespread']
